import Responsive from "../Responsive";
import styles from "./styles/caracteristiqueStyles";

const Caracteristique = ({
  setCaracteristiques,
  caracteristique,
  translations,
}) => {
  const handleChange = (key) => (e) => {
    const updatedCaracteristique = {
      ...caracteristique,
      [key]: e.target.checked,
    };
    setCaracteristiques(updatedCaracteristique);
  };

  return (
    <div style={styles.container}>
      {Object.keys(caracteristique)
        .filter((key) => key !== "id")
        .map((key) => (
          <Responsive key={key} className="p-5" m={1} l={1} xl={1}>
            <label style={styles.label}>
              {translations[key] || key}
              <input
                type="checkbox"
                checked={caracteristique[key]}
                onChange={handleChange(key)}
              />
            </label>
          </Responsive>
        ))}
    </div>
  );
};

export default Caracteristique;
